module.exports = __webpack_public_path__ + "assets/img/logo_white.db56a00b.png";